import { ClipLoader } from "react-spinners";


const Loader = ({loading}) => {

    const override = {
        display: "block",
        margin: "0 auto",
        borderColor: "#0B4141",
      };

      
      let color = "#0B4141";
    return (
      <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)', // or use rgba(255,255,255,0.8) for semi-transparent
        zIndex: 10,
      }}
    >
      <ClipLoader
        color={color}
        loading={loading}
        cssOverride={override}
        size={100}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
    )
}

export default Loader;